import { render, staticRenderFns } from "./NotificacaoPenalidade.vue?vue&type=template&id=5c247bf4"
import script from "./NotificacaoPenalidade.vue?vue&type=script&lang=js"
export * from "./NotificacaoPenalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports